import { IInTransitService } from './IInTransitService';
import { of as observableOf, Observable } from 'rxjs';
import { HttpRequestService } from '../../http-request.service';
import { apiURLs, PREVILEGEKEY } from '../../../globalcontants';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TransferEntity } from '../../../models/Transactions/TransferEntity';
import { ValidationEntity } from '../../../models/Utilities/ValidationEntity';
import { TransactionHeaderEntity } from '../../../models/Transactions/DocumentApprovalEntity';
@Injectable({
  providedIn: 'root'
})
export class InTransitService implements IInTransitService {
  constructor(private httpService: HttpRequestService) { }

  GetTransfersSummary(
    siteId: number,
    transType: number,
    menuId: number,
    selectedLocationId: number = 0, itemId: number = 0, searchText: string = '')
    : Observable<TransferEntity[]> {

    let inputParams = new HttpParams().set('siteId', siteId.toString())
      .set('transType', transType.toString())
      .set('menuId', menuId.toString())
      .set('selectedLocationId', selectedLocationId.toString())
      .set('itemId', itemId.toString())
      .set('APIKEY', PREVILEGEKEY.GetTransfersSummary);
    if (searchText !== '') {
      inputParams = inputParams.append('searchValue', searchText.toString());
    }
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.TransfersAPI.GetTransfersSummary);
  }

  /**
   * @version UI 13.2
   * @method GetAllTranasction
   * @param QueryParams 
   * @returns 
   */

  GetAllTranasction(QueryParams: any): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.GetAllInTransitDelivery, QueryParams);
  }

  GetTranasctionDetailsCount(TypeIds: any): Observable<any> {
    const transferRequestUrl = apiURLs.TransactionManagement.GetDetailsCount + '?TypeIds=' + TypeIds;
    return this.httpService.GetHttpRequest(transferRequestUrl);
  }

  GetInTransitData(QueryParams: any): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.GetInTransitData, QueryParams);
  }

  SaveInTransit(QueryParams: any): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.SaveInTransit, QueryParams);
  }

  GetTransferDetails(menuId: number, transferNumber: number, siteId: number): Observable<TransferEntity> {
    const inputParams = new HttpParams().set('menuId', menuId.toString())
      .set('transferNumber', transferNumber.toString())
      .set('siteId', siteId.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.TransfersAPI.GetTransfersDetails);

  }

  /**
 * @version 13.2 UI
 * @method GetTransDetails
 * @param transTypeId;
 * @param transferId;
 * @returns;
 * oldmethod - GetTransferDetails
 */

  GetTransDetails(transTypeId: number, transferId: number): Observable<any> {
    const reqHeadUrl = `${apiURLs.TransactionManagement.GetTransferHead}/` + transferId + `?transtype=${transTypeId}`;
    return this.httpService.GetHttpRequest(reqHeadUrl);
  }

  PostTransfer(entity: TransferEntity): Observable<ValidationEntity> {
    (entity as any).APIKEY = PREVILEGEKEY.PostTransfer;
    return this.httpService.postHttpRequest(apiURLs.TransfersAPI.SaveTransfer, entity);
  }
  /**
    * @version UI 13.2
    * @method GetTransGetRequistionSummary
    */
  // GetTransferRequistionSummary(TransferRequistionRequestParams: any): Observable<any> {
  //   const requisitionRequestUrl = apiURLs.TransfersAPI.GetTransferRequistionSummary + TransferRequistionRequestParams
  //   return this.httpService.GetHttpRequest(requisitionRequestUrl);
  // }
  GetInTransitHeaderSummary(typeId: number = 35): Observable<TransactionHeaderEntity> {
    const requestUrl = apiURLs.InvertoryManagement.GetTransactionHeader + typeId;
    return this.httpService.GetHttpRequest(requestUrl);
  }
  /**
   * @version 13.1 UI
   * @param RequisitionRequestParams 
   * @returns 
   */
  GetTransOpenRequestSummary(RequisitionRequestParams: any): Observable<any> {
    const requisitionRequestUrl = apiURLs.TransactionManagement.GetRequisitionHead + RequisitionRequestParams
    return this.httpService.GetHttpRequest(requisitionRequestUrl);
  }

    /**
   * @version 13.2 UI
   * @param PostTrans 
   * @returns 
   */
  PostTrans(entity: any): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.GetTransferHead, entity);
  }

  GetAllTransferAckParts(QueryParams: any): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.GetAllTransferAckParts, QueryParams);
  }
}
